import { RgCoreVersion } from "@project-rouge/rg-core";
import { RgThreeVersion } from "@project-rouge/rg-three";
import { RgAggregatorVersion } from "./index81.js";
const getRgVersions = () => ({
  core: RgCoreVersion,
  three: RgThreeVersion,
  aggregator: RgAggregatorVersion
});
export {
  getRgVersions
};
//# sourceMappingURL=index79.js.map
